import React from 'react';
import InputSelect from '../../../../../component/inputSelect/InputSelect';
import InputField from '../../../../../component/form/FormInput';
import { validateGSTNumber, validatePANCard } from '../../../../../utils/utility';

const OtherDetails = ({ customerType, data, setCustomerData, disabled, error, setError }) => {
	const handleOtherDetailsInputChange = (key, value) => {
		setCustomerData((prev) => ({
			...prev,
			othersDetails: {
				...prev.othersDetails,
				[key]: value,
			},
		}));

		if (key === 'pan_number') {
			if (value !== '' && value !== null) {
				if (!validatePANCard(value)) {
					const newError = { ...error, [key]: 'Pan number is not valid' };
					setError(newError);
				} else {
					const newError = { ...error };
					delete newError?.[key];
					setError(newError);
				}
			} else {
				const newError = { ...error };
				delete newError?.[key];
				setError(newError);
			}
		} else if (key === 'gst_number') {
			if (value !== '' && value !== null) {
				if (!validateGSTNumber(value)) {
					const newError = { ...error, [key]: 'Gst number is not valid' };
					setError(newError);
				} else {
					const newError = { ...error };
					delete newError?.[key];
					setError(newError);
				}
			} else {
				const newError = { ...error };
				delete newError?.[key];
				setError(newError);
			}
		} else {
			if (value && error[key]) {
				delete error?.[key];
			}
		}
	};

	return (
		<div>
			<div className="row mt-1">
				<div className="col-6">
					<InputField
						label="PAN"
						placeholder="PAN Number"
						type="text"
						autoComplete="off"
						value={data.pan_number}
						onChange={(value) => handleOtherDetailsInputChange('pan_number', value)}
						disabled={disabled}
						error={error?.pan_number}
						showValidateIcon={true}
					/>
				</div>
				<div className="col">
					<InputSelect
						options={[]}
						label="Currency"
						placeholder="Customer Currency"
						autoComplete="off"
						returnInputValue={true}
						onChange={(value) => handleOtherDetailsInputChange('currency', value)}
						value={'INR'}
						disabled={true}
					/>
				</div>
			</div>
			<div className="row">
				{customerType === 1 && (
					<div className="col-6">
						<InputField
							label="GST"
							autoComplete="off"
							placeholder="GST Number"
							value={data.gst_number}
							onChange={(value) => handleOtherDetailsInputChange('gst_number', value)}
							type="text"
							disabled={disabled}
							error={error?.gst_number}
							showValidateIcon={true}
						/>
					</div>
				)}
				<div className="col-3">
					<div style={{ marginBottom: '10px', marginTop: '1px', color: '#000000' }}>
						<span> Enable Portal</span>
						<label
							style={{ display: 'flex', alignItems: 'center', gap: '10px', marginTop: '5px' }}
						>
							<input
								type="checkbox"
								autoComplete="off"
								checked={data.is_enable_portal}
								style={{ width: '20px', height: '20px' }}
								onChange={(e) => {
									handleOtherDetailsInputChange('is_enable_portal', e.target.checked);
								}}
								disabled={disabled}
							/>
							Enable Portal
						</label>
					</div>
				</div>
			</div>
		</div>
	);
};

export default OtherDetails;
